<template>
  <div class="qa-common-title-wrap" :style="{ 'padding-bottom': pdb }">
    <img :src="icon" alt="" class="qa-common-title-img" />
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String
    },
    pdb: {
      type: String,
      default: '0.13rem'
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.qa-common-title-wrap {
  .qa-common-title-img {
    width: auto;
    height: 32px;
  }
}
</style>
